// Preços fixos de adicionais e puxadores usados na precificação Mini.
// Compartilhado entre CalculadoraCusto.jsx (UI interna) e api/calcular-orcamento.js
// (endpoint que a Vendedora IA usa).
//
// Fonte da verdade — atualize aqui quando preço de adicional/puxador mudar.

export const PRECO_ADICIONAL = {
  rodinhas:         100,
  pePalito:          60,
  baseMadeira:      150,
  baseMetalon:      350,
  moldura:          200,
  espessura25mm:      0,  // tratado separado (multiplicador 1.25 no preço base)
  gavetaBranco:     180,
  gavetaCor:        240,
  chaves:            60,
  prateleiraBranco:  80,
  prateleiraCor:    110,
}

export const PRECO_PUXADOR = {
  'Fecho e toque':  0,
  'Cava':           0,
  'Alça':          50,
  'Concha':        40,
  'Ponto':         20,
  'Passante':      30,
}
